import { render, staticRenderFns } from "./ProjectResponseHeader.vue?vue&type=template&id=03e5c8d9&scoped=true"
import script from "./ProjectResponseHeader.vue?vue&type=script&lang=js"
export * from "./ProjectResponseHeader.vue?vue&type=script&lang=js"
import style0 from "./ProjectResponseHeader.vue?vue&type=style&index=0&id=03e5c8d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e5c8d9",
  null
  
)

export default component.exports